import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';

import { useMainSelector } from './useMainSelector';

export function useUserEnvironment(): MainStoreUserEnvironmentState {
  return useMainSelector((state) => state.userEnvironment);
}
